import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";

// Images
import TestimonialTopVector from "../../Assets/Images/LandingPage/testimonial_vector_top.svg";
import QouteIcon from "../../Assets/Images/LandingPage/footer-links.png";


export const TestimonialsContainer = styled.div`
    .testimonials_section{
        padding-bottom: 120px;
        position: relative;
        &:before{
            display:none;
            position: absolute;
            content: "";
            background: url(${TestimonialTopVector}) no-repeat;
            width: 100%;
            height: 100%;
            bottom: 0;
            right: 0;
            background-position: top center;
            background-size: 500px;
        }
        mygrid-container{
          position: relative;
          z-index: 1;  
        }
    }
    .testi-graphic-img {
        position: relative;
        left: -70px;
    }
    .testimonial-inner-wrapper {
        display: flex;
        align-items: center;
        background: linear-gradient(to right,transparent 28px,#FFF9EB 28px);
        border-radius: 0 50px;
        position:relative;
        &:before{
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            width: 100%;
            height: 45px;
            background-position: top;
            background-color: #fff;
        }
        &:after{
            background: url(${QouteIcon}) no-repeat;
            content: "";
            position: absolute;
            bottom: 50px;
            right: 80px;
            width: 50px;
            height: 50px;
            background-position: bottom right;
            background-size: 46px;
        }
    }
    .testimonial_cara {
        padding: 60px;
        text-align: center;
        top: 45px;
        position: relative;
        width: 100%;
         overflow: hidden
        p{
            color: #021E40;
        }
    }
    .testimonial_item {
        text-align: center;
        max-width: 500px;
        margin: auto;
        padding: 20px;
    }

    .testimonial_desc {
        margin-bottom: 20px;
        color: #021E40;
        text-align: center;
    }

    .testimonial_name {
        font-size: 20px;
        font-weight: 600;
        margin: 0;
        color: #000;
    }
    p.testimonial_position {
        color: #EE2D2F !important;
        font-weight: 700;
        text-transform: uppercase;
        margin-top: 2px;
    }
    .testimonial_position {
        font-size: 16px;
        color: #888;
    }

    .testimonial_slider_wrap {
        width: 100%;
        max-width: 600px;
        margin: 0 auto;
        overflow: hidden; 
    }

    .slick-slider {
        overflow: hidden;
    }

    .slick-list {
        overflow: hidden !important;
    }

    .slick-track {
        display: flex !important;
        align-items: stretch;
    }


    @media (max-width: 1199px){
    
        .testimonial-inner-wrapper{
            flex-wrap: wrap;
            flex-direction: column-reverse;
            background: #FFF9EB;
        }
        .testi-graphic-img{
            width: 100%;
            left: 0;
            text-align: center;
        }
        .testimonial-inner-wrapper:before{
            display:none;
        }
         .testimonial_cara{
            width:100%;
            top:0;
            padding: 50px 40px;
            max-width: 982px;
            padding-top: 90px;
            padding-bottom: 30px;
         }    
        .testi-graphic-img img {
            width: 100%;
            max-width: 450px;
        }
        .testimonials_section {
            padding-bottom: 70px;
        }
        .testimonial_cara {
            padding-top: 70px;
        }
        .testimonial-inner-wrapper:after{
            display:none;
        }
    
    }
    @media (max-width: 1024px){

      
    }
    @media (max-width: 991px){
        .testimonial_cara {
            padding: 56px 84px;
            padding-top: 56px;
        }
    }
    @media (max-width: 767px){
        .testimonial_cara {
            padding: 50px 25px;
            padding-top: 70px;
            padding-bottom: 30px;
        }
    }

`;